import React, { useState, useEffect } from "react";
import { Menu, X, ArrowUpRight } from "lucide-react";
import Logo from "@/components/Logo";

const NAV = [
  { label: "Products", href: "#products" },
  { label: "Industries", href: "#industries" },
  { label: "Process", href: "#process" },
  { label: "Why Us", href: "#why" },
  { label: "Contact", href: "#quote" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 8);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-navbar"
      className={`sticky top-0 z-50 w-full transition-all duration-300 ${
        scrolled
          ? "bg-white/90 backdrop-blur-xl border-b border-[#d1d5db]"
          : "bg-white border-b border-transparent"
      }`}
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="flex items-center justify-between h-[104px]">
          <a
            href="#top"
            data-testid="nav-logo-link"
            className="flex items-center"
          >
            <Logo height={80} />
          </a>

          <nav className="hidden lg:flex items-center gap-1">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                data-testid={`nav-link-${item.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="px-4 py-2 text-[13px] font-bold uppercase tracking-[0.12em] text-[#1B3F8F] hover:text-[#F58220] transition-colors"
              >
                {item.label}
              </a>
            ))}
          </nav>

          <div className="hidden lg:flex items-center gap-3">
            <a
              href="tel:+919327903300"
              data-testid="nav-phone"
              className="text-[13px] font-semibold text-[#0a1128] hover:text-[#F58220] transition-colors"
            >
              +91 93279 03300
            </a>
            <a
              href="#quote"
              data-testid="nav-cta-quote"
              className="group inline-flex items-center gap-2 bg-[#F58220] hover:bg-[#d9701a] text-white px-5 py-3 text-[12px] font-bold uppercase tracking-[0.14em] transition-colors"
            >
              Get a Quote
              <ArrowUpRight
                size={14}
                className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
              />
            </a>
          </div>

          <button
            data-testid="nav-mobile-toggle"
            aria-label="Toggle menu"
            onClick={() => setOpen((v) => !v)}
            className="lg:hidden inline-flex items-center justify-center w-10 h-10 border border-[#d1d5db] text-[#1B3F8F]"
          >
            {open ? <X size={18} /> : <Menu size={18} />}
          </button>
        </div>
      </div>

      {open && (
        <div
          data-testid="nav-mobile-menu"
          className="lg:hidden border-t border-[#d1d5db] bg-white"
        >
          <div className="px-6 py-4 flex flex-col gap-1">
            {NAV.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={() => setOpen(false)}
                data-testid={`mnav-link-${item.label.toLowerCase()}`}
                className="py-3 text-sm font-bold uppercase tracking-[0.14em] text-[#1B3F8F] border-b border-[#eef0f4]"
              >
                {item.label}
              </a>
            ))}
            <a
              href="#quote"
              data-testid="mnav-cta-quote"
              onClick={() => setOpen(false)}
              className="mt-3 inline-flex items-center justify-center gap-2 bg-[#F58220] text-white px-5 py-3 text-sm font-bold uppercase tracking-[0.14em]"
            >
              Get a Quote
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
